const LOGOS = [
  "Heron Bay HOA",
  "Coral Ridge Towers",
  "Sunrise Lakes Phase III",
  "Boca Grove Estates",
  "Kings Point 55+",
  "Weston Hills Condo",
  "Palm-Aire Country Club",
  "Century Village",
  "Wynmoor Village",
  "Aventura Marina",
];

export default function TrustBar() {
  return (
    <section className="bg-background-100 border-y border-background-200 py-10">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <p className="text-center text-foreground-500 text-xs uppercase tracking-[0.22em] mb-6">
          Trusted by boards, property managers &amp; community associations across South Florida
        </p>
        <div className="overflow-hidden">
          <div className="marquee-track flex gap-14 w-[200%]">
            {[...LOGOS, ...LOGOS].map((name, i) => (
              <div
                key={`${name}-${i}`}
                className="flex items-center gap-3 text-foreground-600 whitespace-nowrap"
              >
                <i className="ri-building-4-line text-primary-600 text-xl" />
                <span className="font-heading text-lg font-medium">{name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}